import type { ElementType } from "@/react/types/Element";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { FormElement } from "./FormElement";

interface HorizontalElementsRendererProps {
  errors: Record<number, string>;
  formElements: ElementType[];
  initialFocusRef?: React.RefObject<HTMLInputElement>;
  isPreview: boolean;
  isSubmitting: boolean;
}
export const HorizontalElementsRenderer = ({
  formElements,
  isPreview,
  initialFocusRef,
  isSubmitting,
  errors,
}: HorizontalElementsRendererProps) => {
  let fieldCount = 0;
  // Title and subtitle are rendered vertically, while other elements are rendered horizontally
  const verticalElements = formElements.filter(
    element => element.type === "text",
  );
  const horizontalElements = formElements.filter(
    element => element.type !== "text",
  );
  const firstInputIndex = horizontalElements.findIndex(
    element => element.type === "field",
  );

  return (
    <>
      {verticalElements.map(element => (
        <FormElement
          key={element.id}
          element={element}
          isPreview={isPreview}
          isSubmitting={isSubmitting}
          errors={errors}
          fieldIndex={-1}
        />
      ))}
      <div className="flex flex-col gap-0 sm:flex-row sm:items-end sm:gap-3">
        {horizontalElements.map((element, index) => {
          const fieldIndex = element.type === "field" ? fieldCount++ : -1;
          return (
            <FormElement
              key={element.id}
              element={element}
              isPreview={isPreview}
              isSubmitting={isSubmitting}
              errors={errors}
              initialFocusRef={
                index === firstInputIndex ? initialFocusRef : undefined
              }
              fieldIndex={fieldIndex}
              className={classNames({
                "mt-4 !h-auto whitespace-nowrap !py-3 sm:mb-2 sm:mt-0 sm:!w-auto sm:justify-between":
                  element.type === "button",
                "w-full": element.type === "field",
              })}
            />
          );
        })}
      </div>
    </>
  );
};
